import React, { createContext, useState, useEffect } from "react";
import { getSessionId } from "../utils/session";

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    // one identity for a visitor, shared with every other component
    setSessionId(getSessionId());
  }, []);

  return (
    <SessionContext.Provider value={{ sessionId, setSessionId }}>
      {children}
    </SessionContext.Provider>
  );
};

export default SessionContext;
